import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import {
	type InspirationCta,
	InspirationCtaButton,
} from "web_myplann/Inspiration/Components/InspirationCtaButton";

type Props = {
	primaryCta?: InspirationCta;
	secondaryCta?: InspirationCta;
	disclaimer: string;
};

export const InspirationDetailFooter: FC<Props> = ({
	primaryCta,
	secondaryCta,
	disclaimer,
}) => (
	<>
		{(primaryCta || secondaryCta) && (
			<Stack pt={2.4} pb={2.4} px={1.6} gap={1.2}>
				{primaryCta && <InspirationCtaButton cta={primaryCta} />}
				{secondaryCta && <InspirationCtaButton cta={secondaryCta} />}
			</Stack>
		)}

		<Typography variant="hint" textAlign="center" relaxed px={1.6} pb={2.4}>
			{disclaimer}
		</Typography>
	</>
);
